import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=455c8784"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=455c8784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports